module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tablet-en.8a52a9aa.webp";